import { LandingHomepageComponent } from './landing-homepage.component';
import { LandingRoutingModule } from './landing-routing.module';
import { LandingHomepageService } from './landing-homepage.service';
import { CommonModule } from '@angular/common'; 
import { SharedModule } from '../../app/shared/modules/shared.module'
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        LandingRoutingModule,
        CommonModule,
        SharedModule
    ],
    declarations: [
        LandingHomepageComponent
    ],
    providers: [LandingHomepageService]
})
export class LandingModule { }
